import { z } from "zod";

/**
 * HCA Moravia — unpaid faktury + upomínky (Sprint 48, §DH-04 + §F-05).
 * UPOMINKA_FAKTURA seriály se automaticky firují z S42 helper při issue.
 * Tento modul přidává KPI widget a filter na faktury listu.
 */

export const unpaidStavFilterSchema = z.enum([
  "vsechny",
  "nezaplacene",
  "po_splatnosti",
  "blizi_se_splatnost",
]);
export type UnpaidStavFilter = z.infer<typeof unpaidStavFilterSchema>;

export const listUnpaidFakturySchema = z.object({
  stav: unpaidStavFilterSchema.default("nezaplacene"),
  daysUntilDue: z.coerce.number().int().min(0).max(365).optional(),
});

export type ListUnpaidFakturyInput = z.infer<typeof listUnpaidFakturySchema>;

export const fireUpominkaInputSchema = z.object({
  fakturaId: z.string().uuid("Neplatné ID faktury"),
});

export type FireUpominkaInput = z.infer<typeof fireUpominkaInputSchema>;
